import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import {
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterModule,
} from '@angular/router';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule],
})
export class BlogComponent {
  private router = inject(Router);

  constructor() {
    const router = this.router;

    // // Debug routes inside the Auth module
    router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        console.log('Navigation started');
      }
      if (event instanceof NavigationEnd) {
        console.log('Navigation ended');
      }
      if (event instanceof NavigationError) {
        console.error('Navigation error', event.error);
      }
    });
  }
}
